__turbopack_context__.v({
  "avatar": "avatar-module-scss-module__esDx3q__avatar",
  "circular": "avatar-module-scss-module__esDx3q__circular",
  "default": "avatar-module-scss-module__esDx3q__default",
  "icon": "avatar-module-scss-module__esDx3q__icon",
  "image": "avatar-module-scss-module__esDx3q__image",
  "large": "avatar-module-scss-module__esDx3q__large",
  "medium": "avatar-module-scss-module__esDx3q__medium",
  "rounded": "avatar-module-scss-module__esDx3q__rounded",
  "secondary": "avatar-module-scss-module__esDx3q__secondary",
  "small": "avatar-module-scss-module__esDx3q__small",
  "square": "avatar-module-scss-module__esDx3q__square",
  "tiny": "avatar-module-scss-module__esDx3q__tiny",
  "x-large": "avatar-module-scss-module__esDx3q__x-large",
  "x-small": "avatar-module-scss-module__esDx3q__x-small",
  "xx-large": "avatar-module-scss-module__esDx3q__xx-large",
});
